import { TextField } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import the from '../objects/the';
import './css/hidden.error.message.css';

export default function InputField(props) {
    const getErrorMessage = () => {
        if (!props.errorMessage)
            return null;
        return <>
            <div style={{
                color: the.color.darkRed,
                fontSize: 14,
            }}>{props.errorMessage}</div>
        </>;
    };
   
    return <>
        <TextField {...props}/>
        {getErrorMessage()}
    </>;
}